module.exports = __webpack_public_path__ + "img/blank-comic-book_B098GSYYD6.860d7f92.jpg";